import React, { FC } from 'react'
import { Container, ContainerProps } from '@mui/material'

const EvtContainer: FC<ContainerProps> = ({ children, ...props }) => {
    return <Container {...props}>{children}</Container>
}

export default EvtContainer
